var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiBuildingFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9993 31.6667H38.3327V35H1.66602V31.6667H4.99935V6.66667C4.99935 6.22464 5.17494 5.80072 5.4875 5.48816C5.80006 5.17559 6.22399 5 6.66601 5H23.3327C23.7747 5 24.1986 5.17559 24.5112 5.48816C24.8237 5.80072 24.9993 6.22464 24.9993 6.66667V31.6667H28.3327V15H33.3327C33.7747 15 34.1986 15.1756 34.5112 15.4882C34.8237 15.8007 34.9993 16.2246 34.9993 16.6667V31.6667ZM11.666 18.3333V21.6667H18.3327V18.3333H11.666ZM11.666 11.6667V15H18.3327V11.6667H11.666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiBuildingFill);
export default __webpack_public_path__ + "static/media/ri_building-fill.ef2a1896717e248d5f91345e9c53a92d.svg";
export { ForwardRef as ReactComponent };